// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const ribombee: PokeData = {
  "id": 743,
  "name": "ribombee",
  "height": 2,
  "weight": 5,
  "base_experience": 162,
  "types": [
    PokeType.BUG,
    PokeType.FAIRY
  ],
  "api_moves": [
    "absorb",
    "stun-spore",
    "sweet-scent",
    "aromatherapy",
    "silver-wind",
    "covet",
    "bug-buzz",
    "switcheroo",
    "quiver-dance",
    "struggle-bug",
    "draining-kiss",
    "fairy-wind",
    "dazzling-gleam",
    "pollen-puff"
  ],
  "moves": [
    "stun-spore",
    "aromatherapy",
    "bug-buzz",
    "dazzling-gleam",
    "pin-missile",
    "string-shot",
    "leech-steal",
    "misty-terrain",
    "mist-terrain",
    "guardian-bond",
    "spirit-break",
    "lunge",
    "sticky-web"
  ],
  "evolution_chain": {
    "id": 382,
    "item": null,
    "species": [
      {
        "name": "cutiefly",
        "order": 742,
        "types": [
          PokeType.BUG,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "ribombee",
        "order": 743,
        "types": [
          PokeType.BUG,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 742,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 89,
    "speed": 176,
    "ability_power": 135
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
